
import { Customer } from "../pages/customer/obj.model";
import { Address } from "../shared/address/address.model";

export class CustomerBase {
    sellerid : number
    sellername : number
    selleriduser : number
}

export class Register {
    regid?: number
    name?: string
    nickname?: string
    registercode?: string
    fileid?: number
    customerbase?: [CustomerBase]
    driver?: [any]
    carrier?: [any]
    address?: [Address]
    customer?: [Customer]
}

export class RegisterPlace {
    regid?: number
    placeid?: number
    xplaceid?: string
    code?: string
    active?: number
    address?: [Address]
    createdby?: number
    createdon?: Date
    modifiedby?: number
    modifiedon?: Date
    deleted?: number
    recid?: number
}

export class Session {
    userid?: number = 0
    username?: string = ''
    email?: string = ''
    passportid?: number = 0
    themeid?: number = 1
    groupid?: number = 0
}
